import React, {Fragment, useState } from 'react';

import { connect } from 'react-redux';
import { FormButton, FormButtonsWrap, FormHeading} from '..';

import { pushMessage, updateAccountFromAuthToken } from '../../actions';

import { AUTHORIZE, requestInfoByIDList } from '../../graphql';

import "react-datepicker/dist/react-datepicker.css";

import ApolloClient from 'apollo-boost';
import { authProvider } from '../../util/auth';

import createStore from '../../store';

const TrackRequestApprover = props => {
  const { account, hideModal, pushMessage } = props;
  const {pers_no, roles} = account;

  /*  RENEW NEW TOKEN AGAIN STARTS  */
  const extractMSALToken = function()
  {
    const timestamp = Math.floor((new Date()).getTime() / 1000)
    let token = null
  
    for (const key of Object.keys(sessionStorage)){
      if (key.includes('"authority":')){
        const val = JSON.parse(sessionStorage.getItem(key))
        if (val.expiresIn){
          // We have a (possibly expired) token
          if (val.expiresIn > timestamp && val.idToken === val.accessToken){
            // Found the correct token
            token = val.idToken
          }
          else{
            // Clear old data
            sessionStorage.removeItem(key)
          }
        }
      }
    }
    if (token) return token
    throw new Error('No valid token found')
  }
  const store = createStore();
  let accessPayload = sessionStorage.getItem('access_token_payload')
  if (accessPayload) {
    //console.log('accessPayload')
    store.dispatch(updateAccountFromAuthToken(JSON.parse(accessPayload)));
  }
  const acquireInternalToken = async function(externalToken)
  {
    if( !acquireInternalToken.promise ){
      acquireInternalToken.promise = new Promise((resolve, reject)=>{
        //console.log('Hi')
        client.query({query: AUTHORIZE, fetchPolicy: "no-cache"}).then((result)=>{
          //console.log(result)
          //console.log('Hi')
          
          sessionStorage.setItem('access_token', result.data.authorize.token)
          if (!accessPayload) {
            sessionStorage.setItem('access_token_payload', JSON.stringify(result.data.authorize.payload))
            store.dispatch(updateAccountFromAuthToken(result.data.authorize.payload));
          }
          resolve( result.data.authorize.token );
        }).catch((error)=>{
          console.log("ERROR acquiring access token")
          console.log(error.message)
          reject(error);
        });
      });
    }
    //console.log('Hello')
    //console.log(await acquireInternalToken.promise)
    return acquireInternalToken.promise
  }
  const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_API,
    request: async (operation) => {
      await authProvider.getAccessToken();
      const adIdToken = await authProvider.getIdToken();
      //console.log(adIdToken);

      let externalToken = sessionStorage.getItem('msal.idtoken')
      // If msal.istoken is not found, then we can extract it from the authority
      if(!externalToken){
        externalToken = extractMSALToken()
      }
      if( externalToken !== adIdToken.idToken.rawIdToken ){
        // External token renewed, need to renew internal as well
        delete acquireInternalToken.promise;
        sessionStorage.removeItem('access_token');
      }

      let internalToken = sessionStorage.getItem('access_token')
      if( externalToken && !internalToken && operation.operationName !== "Authorize" ){
        // Exchange external token to internal token
        internalToken = await acquireInternalToken( externalToken )
      }
      if( internalToken ){
        operation.setContext({
          headers: {
            authorization: `Bearer ${internalToken}`
          }
        })
      }
      else if( externalToken ){
        operation.setContext({
          headers: {
            authorization: `Bearer ${externalToken}`
          }
        })
      }
    },
    onError: ({ graphQLErrors, networkError, operation, forward }) => {
      //console.log(graphQLErrors);
      if (graphQLErrors) {
        
      }
    }
  });
  /*  RENEW NEW TOKEN AGAIN ENDS  */
  
  
  

  
  
  const handleQuit = event => { hideModal(); 
    
    
  };

  let inputText = '';
  
  const _executeSearch = async (evt) => {

    var enteredRequestID = '';
    document.getElementById('frmRequestID_error').innerHTML = '&nbsp;';
    document.getElementById('frmRequestID_error').style.display = 'none';

    inputText = evt.target.value;
    inputText = inputText.trim();
    //console.log(inputText);
    //setSearchTxtValue(inputText);
    
    /*  QUERY FIRE FOR FETCHING RECORDS WITH ENTERED KEYWORD STARTS  */
    var lengthOfInputText = inputText.length;
    if(lengthOfInputText >= 4)
    {
      var reg = new RegExp('^[0-9]+$');
      if(reg.test(inputText) === true)  /*  IF TEXT IS NUMBER   */
      {
        enteredRequestID = inputText;
        document.getElementById('frmRequestInformation').innerHTML = '&nbsp;';
        document.getElementById('frmLoader').style.display = 'block';
        const where_1 = { employee_request_id: enteredRequestID};
        const requestInfoSearchResult = await client.query({
          query: requestInfoByIDList,
          variables: { where: where_1, limit : 1 } ,
        });
        document.getElementById('frmLoader').style.display = 'none';

        //console.log("requestInfoSearchResult===>", requestInfoSearchResult);
        //console.log("requestInfoSearchResultLength===>", requestInfoSearchResult.data.requestInfoByIDList.items.length);
        if(requestInfoSearchResult.data.requestInfoByIDList.items.length > 0)
        {
          //console.log("requestInfoSearchResult===>", requestInfoSearchResult.data.requestInfoByIDList.items[0].employee_request_id);

          var requestType = requestInfoSearchResult.data.requestInfoByIDList.items[0].request_type;
          var requestWorkFlow = requestInfoSearchResult.data.requestInfoByIDList.items[0].reason_code;
          var requestCountry = requestInfoSearchResult.data.requestInfoByIDList.items[0].request_country;
          if(requestInfoSearchResult.data.requestInfoByIDList.items[0].requesterEmployee[0])
          {
            var requestRaisedByName = requestInfoSearchResult.data.requestInfoByIDList.items[0].requesterEmployee[0].full_name;
            var requestRaisedByEmail = requestInfoSearchResult.data.requestInfoByIDList.items[0].requesterEmployee[0].email_work;
          }
          else
          {
            var requestRaisedByName = 'N/A';
            var requestRaisedByEmail = 'N/A';
          }

          if(requestInfoSearchResult.data.requestInfoByIDList.items[0].targetEmployee[0])
          {
            var requestRaisedForName = requestInfoSearchResult.data.requestInfoByIDList.items[0].targetEmployee[0].full_name;
            var requestRaisedForEmail = requestInfoSearchResult.data.requestInfoByIDList.items[0].targetEmployee[0].email_work;
          }
          else
          {
            var requestRaisedForName = 'N/A';
            var requestRaisedForEmail = 'N/A';
          }

          var requestApprovals = requestInfoSearchResult.data.requestInfoByIDList.items[0].requestApprovals;
          var approversInfoStr = ''; 
          if(requestApprovals.length > 0)
          {
            approversInfoStr += '<table cellspacing="1" cellpadding="1" width="100%" border="1">';
              approversInfoStr += '<tr>';
                approversInfoStr += '<td><b>Level</b></td>';
                approversInfoStr += '<td><b>Approver Type</b></td>';
                approversInfoStr += '<td><b>Current Approver</b></td>';
                approversInfoStr += '<td><b>Actual Approver</b></td>';
                approversInfoStr += '<td><b>Approver Change Reason</b></td>';
                approversInfoStr += '<td><b>Approval Status</b></td>';
              approversInfoStr += '</tr>';
              for(var incr_app = 0; incr_app < requestApprovals.length; incr_app++)
              {
                var ApproverType = requestApprovals[incr_app].approverRoleTitle;
                var CurrentApproverEmail = '';
                var CurrentApproverName = '';
                var CurrentApproverDisplayStr = '';

                var ActualApproverEmail = '';
                var ActualApproverName = '';
                var ActualApproverDisplayStr = '';

                var ApproverChangeReason = '';

                if(requestApprovals[incr_app].approverInfo)
                {
                  CurrentApproverName = requestApprovals[incr_app].approverInfo.full_name;
                  CurrentApproverEmail = requestApprovals[incr_app].approverInfo.email_work;

                  CurrentApproverDisplayStr = CurrentApproverName+' ['+CurrentApproverEmail+']';
                }
                else
                {
                  CurrentApproverDisplayStr = '[Inactive User]';
                }
                
                if(requestApprovals[incr_app].realApproverInfo)
                {
                  ActualApproverEmail = requestApprovals[incr_app].realApproverInfo.email_work;
                  ActualApproverName = requestApprovals[incr_app].realApproverInfo.full_name;
                  ActualApproverDisplayStr = ActualApproverName+' ['+ActualApproverEmail+']';
                }
                else
                {
                  ActualApproverDisplayStr = '[Inactive User]';
                  
                }

                if(requestApprovals[incr_app].approverInfo && requestApprovals[incr_app].realApproverInfo)
                {
                  if(ActualApproverEmail == CurrentApproverEmail)
                  {
                    ApproverChangeReason = 'N/A';
                  }
                  else
                  {
                    ApproverChangeReason = 'Actual Approver should be assigned but due to data issue it could not be.';
                  }
                }
                else if(requestApprovals[incr_app].approverInfo && !requestApprovals[incr_app].realApproverInfo)
                {
                  ApproverChangeReason = 'Actual Approver does not exists against employee.';
                }
                else if(!requestApprovals[incr_app].approverInfo && requestApprovals[incr_app].realApproverInfo)
                {
                  ApproverChangeReason = 'Current Approver does not exists against employee.';
                }
                
                var ApproverStatus = requestApprovals[incr_app].approval_status;

                var appLevel = incr_app;
                var appLevelStr = '';
                if(parseInt(appLevel) + parseInt(1) == '1')
                  appLevelStr = '1st';
                else if(parseInt(appLevel) + parseInt(1) == '2')
                  appLevelStr = '2nd';
                if(parseInt(appLevel) + parseInt(1) == '3')
                  appLevelStr = '3rd';
                if(parseInt(appLevel) + parseInt(1) == '4')
                  appLevelStr = '4th';
                if(parseInt(appLevel) + parseInt(1) == '5')
                  appLevelStr = '5th';
                if(parseInt(appLevel) + parseInt(1) == '6')
                  appLevelStr = '6th';

                approversInfoStr += '<tr>';
                  approversInfoStr += '<td>'+appLevelStr+'</td>';
                  approversInfoStr += '<td>'+ApproverType+'</td>';
                  approversInfoStr += '<td>'+CurrentApproverDisplayStr+'</td>';
                  approversInfoStr += '<td>'+ActualApproverDisplayStr+'</td>';
                  approversInfoStr += '<td>'+ApproverChangeReason+'</td>';
                  approversInfoStr += '<td>'+ApproverStatus.charAt(0).toUpperCase() + ApproverStatus.slice(1)+'</td>';
                approversInfoStr += '</tr>';
              }
            approversInfoStr += '</table>';
          }
          

          var requestInfoStr = '';
          requestInfoStr += '<span style="float:left; width:100%; margin:0 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request Type: </b></span>';
            requestInfoStr += '<span style="float:left; width:60% color:#000">'+requestType+'</span>';
          requestInfoStr += '</span>';

          requestInfoStr += '<span style="float:left; width:100%; margin:1% 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request Workflow: </b></span>';
            requestInfoStr += '<span style="float:left; width:60% color:#000">'+requestWorkFlow+'</span>';
          requestInfoStr += '</span>';

          requestInfoStr += '<span style="float:left; width:100%; margin:1% 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request Country: </b></span>';
            requestInfoStr += '<span style="float:left; width:60% color:#000">'+requestCountry+'</span>';
          requestInfoStr += '</span>';

          requestInfoStr += '<span style="float:left; width:100%; margin:1% 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request Raised By: </b></span>';
            requestInfoStr += '<span style="float:left; width:60% color:#000">'+requestRaisedByName+' ['+requestRaisedByEmail+']</span>';
          requestInfoStr += '</span>';

          requestInfoStr += '<span style="float:left; width:100%; margin:1% 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request For: </b></span>';
            requestInfoStr += '<span style="float:left; width:60% color:#000">'+requestRaisedForName+' ['+requestRaisedForEmail+']</span>';
          requestInfoStr += '</span>';

          requestInfoStr += '<span style="float:left; width:100%; margin:1% 0 0 0">';
            requestInfoStr += '<span style="float:left; width:15%"><b>Request Approver(s): </b></span>';
            requestInfoStr += '<span style="float:left; width:85%; color:#000">'+approversInfoStr+'</span>';
          requestInfoStr += '</span>';

          document.getElementById('frmRequestInformation').innerHTML = requestInfoStr;

        }
        else
        {
          document.getElementById('frmRequestID_error').innerHTML = 'Sorry! Request ID is invalid.';
          document.getElementById('frmRequestID_error').style.display = 'block';
          return false;
        }
        
      }
      else
      {
        document.getElementById('frmRequestID_error').innerHTML = 'Sorry! Request ID should be numeric only.';
        document.getElementById('frmRequestID_error').style.display = 'block';
        return false;
      }
    }
    else
    {
      document.getElementById('frmRequestInformation').innerHTML = '&nbsp;';
    }
    /*  QUERY FIRE FOR FETCHING RECORDS WITH ENTERED KEYWORD ENDS  */
    
  }
  
  return (
    
    <div style={{height:'500px'}}>  {/* added height for delagete model UI chnages */}
      <FormHeading>Track Request's Approval Chain</FormHeading>
      <Fragment>
        <div style={{width:'80%', width:'100%', border:'0px solid', margin: '3% 0 0 0'}}>
          <div style={{width:'100%', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}><b>Request ID:</b></span>
            <span style={{float:'left', width:'35%'}}>
            <input type="text" name="frmRequestID" id="frmRequestID" 
              placeholder="Type Request ID [at least 4 characters]" style={{width:'100%', border:'1px solid #000', 'line-height':'35px'}} onBlur={_executeSearch}/>
            </span>
            
            <span style={{float:'right', width:'90%', border: '0px solid', 'min-height': '22px', 'max-height': '140px', position: 'relative', overflow: 'auto', display: 'none', color: 'red'}} id="frmRequestID_error">&nbsp;</span>

            <span id="frmLoader" style={{float:'right', width:'90%', 'margin-left':'1%', display: 'none'}}><img src="./animated-ajax-1.gif" /></span>
          </div>

          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>
          
          <div style={{width:'100%', float:'left', width:'100%', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}><b>Request Information:</b></span>
            <span style={{float:'left', width:'85%'}} id="frmRequestInformation">&nbsp;</span>
          </div>
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>

          <div style={{width:'100%', float:'left', border:'0px solid'}}>
            <span style={{float:'left', width:'10%'}}>&nbsp;</span>
            <span style={{float:'left', width:'60%'}}>
              <FormButtonsWrap>
                <FormButton onClick={handleQuit}>Quit</FormButton>
              </FormButtonsWrap>
            </span>
          </div>
          <div style={{width:'100%', float:'left', border:'0px solid'}}>&nbsp;</div>
          
          
        </div>
      </Fragment>
         
    </div>
  );
};

const mapStateToProps = state => {
  return {
    account: state.account
  };
};

export default connect(
  mapStateToProps,
  { pushMessage }
)(TrackRequestApprover);

